import { compact, uniq } from 'lodash/fp'
import { useEffect, useState } from 'react'
import useBackendClient from '~/api/BackendClient/useBackendClient'
import { BulkExportCultureMetadataResponse } from '~/api/backend/pages/bulkExportCultureMetadataAPI'
import Toaster from '~/components/Toaster'
import useDebouncedAPIEndpoint from '~/utils/hooks/useDebouncedAPIEndpoint'
import BulkExportCultureMetadataContents from './BulkExportCultureMetadataContents'

const BulkExportCultureMetadata = () => {
  const [rawData, setRawData] = useState('')
  const [parsedData, setParsedData] =
    useState<BulkExportCultureMetadataResponse | null>(null)
  const client = useBackendClient()
  const plateBarcodesToFetch = uniq(compact(rawData.split('\n')))

  const {
    response: parseDataDebouncedResponse,
    debouncedAPIEndpoint: debouncedParseData,
    loading: isParsingData,
  } = useDebouncedAPIEndpoint<string[], BulkExportCultureMetadataResponse>(
    async (plateBarcodes: string[]) => {
      return client.bulkExportCultureMetadata.getData({ plate_barcodes: plateBarcodes })
    },
    500,
    !!rawData,
  )

  useEffect(() => {
    if (parseDataDebouncedResponse === null) {
      setParsedData(null)
    } else if (parseDataDebouncedResponse.type === 'response') {
      setParsedData(parseDataDebouncedResponse.response)
    } else if (parseDataDebouncedResponse.type === 'error') {
      Toaster.show({
        message: parseDataDebouncedResponse.message,
        intent: 'danger',
      })
      setParsedData(null)
    }
  }, [parseDataDebouncedResponse])

  useEffect(() => {
    // Null responses must be passed through the debounced API call, so
    // they don't get overwritten by stale responses.
    debouncedParseData(plateBarcodesToFetch.length > 0 ? plateBarcodesToFetch : null)
  }, [rawData])

  return (
    <BulkExportCultureMetadataContents
      plateBarcodesToFetch={plateBarcodesToFetch}
      rawData={rawData}
      setRawData={setRawData}
      parsedData={parsedData}
      isParsingData={isParsingData}
    />
  )
}

export default BulkExportCultureMetadata
